export const userKey = 'user'

export const typesValidation =  {
    AMOUNTNOTIFICATION: 'amountNotification',
    AMOUNTWAITEDTIME: 'amountWaitedTime',
}

export const typeChecks = {
    START: 'startClass',
    END: 'endClass',
    CONTROL: 'control',
    CONTROLASISTENCIA: 'control_asistencia',
    CONTROLPERMANENCIA: 'control_permanencia'
}

export const views = {
    CONTROLASITENCIA: 'controlAsistencia',
    REPORTES: 'reportes',
}

export const colors = {
    PRINCIAPL : '#002E5E',
    RED:'#EC0000',
    WHITE: '#ffffff',
    COLOR: '#636363',
    GREEN: '#198754',
}

export const initialPagination = {
    previousPage: null,
    currentPage: 1,
    nextPage: null,
    totalPages: 1,
    pageSize: 10,
    totalRecords: 0,
    offset: 0,
}

export const minutesToEndClass = 15

export const periodos = ['0 - Anual', '1 - 1er Semestre', '2 - 2do Semestre', '3 - Verano', '4 - Invierno']
